import { useState, useEffect } from 'react';
import { getCarehomeInfo } from '@api/carehome-info';
import { ApiResponse } from '@typings/ApiResponse';
import { CareInfoDetails, CarehomeAddressType } from '@typings/CarehomeInfo';
import { AddressPageType } from '@components/team-member/organization-details';

const useGetCarehomeInfo = (partnerId: string | null) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [addressPageType, setAddressPageType] = useState(AddressPageType.ADD);
  const [savedCarehomeAddressFromTeams, setSavedCarehomeAddressFromTeams] =
    useState<CarehomeAddressType>({
      addressLine1: '',
      addressLine2: '',
      city: '',
      county: '',
      postCode: '',
    });

  useEffect(() => {
    const fetchCarehomeInfo = async () => {
      if (!partnerId) return;

      try {
        const response: ApiResponse<CareInfoDetails> =
          await getCarehomeInfo(partnerId);

        if (response?.status === 'success' && response.data) {
          setAddressPageType(AddressPageType.EDIT);
          setSavedCarehomeAddressFromTeams({
            addressLine1: response.data.address_line1,
            addressLine2: response.data.address_line2,
            city: response.data.city,
            county: response.data.county,
            postCode: response.data.post_code,
          });
          setPhoneNumber(response.data.phone_number);
        } else {
          setSavedCarehomeAddressFromTeams({
            addressLine1: '',
            addressLine2: '',
            city: '',
            county: '',
            postCode: '',
          });
          setPhoneNumber('');
          setAddressPageType(AddressPageType.ADD);
        }
      } catch (error) {
        console.error('Error fetching care home info:', error);
      }
    };

    fetchCarehomeInfo();
  }, [partnerId]);

  return {
    savedCarehomeAddressFromTeams,
    phoneNumber,
    setPhoneNumber,
    addressPageType,
  };
};

export default useGetCarehomeInfo;
